module.exports = __webpack_public_path__ + "static/media/example-content.d87bb7b9.png";